import type { ContinuationSurface } from './analytics';

const PENDING_CONTINUATION_KEY = 'numerology.pendingContinuation';

export interface PendingContinuation {
  question: string;
  sourceSurface?: ContinuationSurface;
  angleType?: string;
  questionRank?: 'primary' | 'secondary';
}

export function rememberPendingContinuation(value: PendingContinuation): void {
  sessionStorage.setItem(PENDING_CONTINUATION_KEY, JSON.stringify(value));
}

export function readPendingContinuation(): PendingContinuation | null {
  const raw = sessionStorage.getItem(PENDING_CONTINUATION_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as PendingContinuation;
    if (!parsed || typeof parsed.question !== 'string' || !parsed.question.trim()) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function continuationNavigationState(pending: PendingContinuation | null): {
  question?: string; autoSend?: boolean; sourceSurface?: ContinuationSurface; angleType?: string; questionRank?: 'primary' | 'secondary';
} {
  if (!pending) return {};
  return {
    question: pending.question,
    autoSend: true,
    sourceSurface: pending.sourceSurface,
    angleType: pending.angleType,
    questionRank: pending.questionRank,
  };
}

export function clearPendingContinuation(question: string): void {
  if (readPendingContinuation()?.question === question) sessionStorage.removeItem(PENDING_CONTINUATION_KEY);
}
